export const socialMediaLinks = {
    facebook: "https://www.facebook.com/HouseAndFlats/",
    instagram: "https://www.instagram.com/houseandflats/",
    linkedin: "https://www.linkedin.com/company/house-and-flats-renting/",
    tiktok: "https://www.tiktok.com/@houseandflats",
    whatsapp: `https://wa.me/5491158860114`
  };

export const whatsappBot = {
    phone: `13055100028`
};

/**
 * Contacto de soporte para los usuarios tipo property (botón "Contactar" del
 * calendario y de Informes, y la burbuja flotante de WhatsApp cuando el
 * logueado es property). Solo dígitos, con código de país: es lo que pide wa.me.
 */
export const propertyContact = {
    phone: `5626318852`
};


export const appRoutes = {
    privacy: "/privacidad",
    faq: "/faq",
    tyc: "/tyc",
    about: "/about",
    investment: "/investment",
    home: "/",
    dashboard: "/dashboard",
    login: "/login"
  };

export const supportedLanguages = ['en', 'es', 'es-ES', 'es-CL', 'fr', 'it', 'de', 'pt'];

export const superAdminEmail = 'cristian@houseandflats.com';
